import { createSelector, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { DayOffsResponse } from 'shared/types/dayoff.types';

const initialState: DayOffsResponse = { data: [], pagination: { page: 1, size: 10, total: 0 } };

export const dayOffSlice = createSlice({
  name: 'dayOff',
  initialState,
  reducers: {},
});

const dayOff = (state: RootState) => state.entities.dayOff;
const getDayOff = createSelector(dayOff, state => state);

export const dayOffSelectors = { getDayOff };
export const actions = dayOffSlice.actions;
export const dayOffReducer = dayOffSlice.reducer;
